<div class="tool-audio">
    <div class="audio-content">
        <div class="mat-display-1">Scan a QR code</div>
        <div class="file-type">
            <mat-hint>Target the QR code</mat-hint>
        </div>
        <div>
            <button mat-raised-button>
                Start scanning
            </button>
        </div>
    </div>
</div>